// @flow
import type {ComponentType} from 'react';
import type {Node} from 'react';

import React from 'react';
import Link from 'react-goose/lib/Link';

type GoToPathname = (pathname: string) => void;

type Config = {
    pathname: string,
    route: string,
    goToPathname: GoToPathname
};

const CreateStateMachineLink = (config: Config): ComponentType<any> => {
    let {pathname, goToPathname, route} = config;
    return ({children}): Node => {

        let onClick = (e) => {
            e.preventDefault();
            goToPathname(pathname);
        };

        return <Link
            spruceName="BlueflagAuthFormLink"
            modifier={`${route} option`}
            href={pathname}
            onClick={onClick}
            children={children}
        />;
    };
};

export default CreateStateMachineLink;
